module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700italic.woff?bf72679ca22e53320beaea090e8bb07d";